var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterSecurebeli({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 357.9 234",
    style: {
      enableBackground: "new 0 0 357.9 234"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F79E1B;}\n\t.st2{fill:#FF5F00;}\n\t.st3{fill:#EB001B;}\n\t.st4{display:none;}\n\t.st5{display:inline;fill:#00A2E5;}\n\t.st6{display:inline;fill:#7375CF;}\n\t.st7{display:inline;fill:#EB001B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.1,216.1c0-15.9,0-31.7,0-47.5c0.1-0.1,0.2-0.1,0.2-0.1c7.9,0.1,15.8-0.8,23.6,0.6 c12.5,2.2,19.8,11.4,19.3,24.1c-0.3,8.7-3.8,15.7-11.8,19.9c-4.1,2.2-8.6,3-13.2,3.1c-5.8,0.1-11.5,0-17.3,0 C53.6,216.2,53.4,216.1,53.1,216.1z M57.2,212c0.2,0.1,0.2,0.2,0.3,0.2c6.1-0.1,12.2,0.1,18.2-0.6c6.4-0.7,11.4-4.1,14.2-10.1 c1.9-4.1,2.1-8.5,1.5-12.9c-0.5-3.8-1.9-7.3-4.6-10.1c-4.1-4.3-9.4-5.8-15.2-5.9c-4.4-0.1-8.8,0-13.2,0c-0.4,0-0.8,0-1.2,0.1 C57.2,185.8,57.2,198.9,57.2,212z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.6,177.8c-1.1,0.7-2.2,1.5-3.4,2.2c-7.4-10.5-22.3-10-30-2.6c-7.8,7.5-7.9,21.5-0.3,29.4 c7.3,7.6,23.1,8.5,30.3-2.3c1.1,0.8,2.2,1.6,3.3,2.4c-4.6,7.8-16.2,11.6-26.4,8.7c-10.9-3.1-17.6-12.5-17.2-24.2 c0.3-11.4,7.6-20.4,18.3-22.9C148.5,166.3,159.7,170.3,163.6,177.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.3,216.1c-1.4,0-2.6,0-3.9,0c0-0.5,0-1,0-1.5c0-5.5,0-11.1,0-16.6c0-1.2-0.1-2.4-0.4-3.6 c-1.1-4.6-5.1-7.4-10.2-7.1c-6.4,0.4-10.4,4.6-10.4,11.2c0,5.4,0,10.7,0,16.1c0,0.5,0,0.9,0,1.5c-1.3,0-2.5,0-3.8,0 c0-16.3,0-32.5,0-48.9c1.2,0,2.4,0,3.7,0c0,7.3,0,14.5,0,22.1c0.4-0.5,0.7-0.7,0.9-0.9c5-6.2,15.5-6.6,21-0.8 c2.1,2.2,3.1,4.9,3.1,7.9C201.4,202.3,201.3,209.1,201.3,216.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.2,201.6c-8.9,0-17.7,0-26.7,0c0.4,4.7,2.4,8.4,6.6,10.3c6.1,2.8,11.6,1.2,16.5-3.2 c0.7,0.9,1.4,1.7,2.1,2.6c-2.7,2.8-5.9,4.5-9.6,5.1c-4.7,0.7-9.1,0.2-13.1-2.6c-4.8-3.4-6.8-8.3-6.5-14.1c0.1-2.3,0.5-4.6,1.4-6.7 c4.1-9.8,16.6-12.7,24.3-5.6c4,3.6,5.3,8.4,5.1,13.6C239.4,201.2,239.3,201.3,239.2,201.6z M212.7,198.1c7.6,0,15.1,0,22.7,0 c-0.2-6.2-4.9-10.9-10.8-11C218.3,187,213.2,191.7,212.7,198.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.4,167.2c1.2,0,2.5,0,3.8,0c0,10.1,0,20.1,0,30.4c1.7,0,3.3,0,4.8,0c0.4,0,0.7-0.4,1-0.7 c3.9-3.8,7.8-7.7,11.6-11.6c0.8-0.9,1.7-1.3,2.9-1.2c1,0.1,1.9,0,2.9,0c-5,5-10,9.9-15.1,15c5.3,5.8,10.4,11.3,15.7,17.1 c-1.8,0-3.3,0-4.7,0c-0.4,0-0.7-0.4-1-0.8c-4-4.4-8-8.7-12-13.2c-0.8-0.8-1.5-1.2-2.6-1.1c-1.1,0.1-2.2,0-3.5,0c0,5.1,0,10,0,15 c-1.4,0-2.6,0-3.9,0C281.4,199.8,281.4,183.5,281.4,167.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.2,209c0.8,0.8,1.6,1.7,2.3,2.5c-3,4.3-10.7,6.3-17,4.4c-6.8-2.1-11.1-8.2-11.1-15.8 c0-7.6,4.3-13.8,11.2-15.9c6.3-1.9,14.1,0.1,17,4.4c-0.8,0.8-1.6,1.6-2.4,2.6c-3.4-3.2-7.4-4.6-12-3.7c-2.9,0.6-5.3,2.1-7.1,4.4 c-3.9,5-3.4,12.8,0.8,17.3C256.6,213.2,264.3,215.1,271.2,209z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36,168.5c1.4,0,2.7,0,4,0c0,15.9,0,31.7,0,47.6c-1.3,0-2.6,0-4,0C36,200.2,36,184.4,36,168.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.6,88.8v-1.5h-0.4l-0.5,1l-0.5-1H153v1.5h0.3v-1.2l0.5,1h0.3l0.5-1v1.2H154.6z M152.1,88.8v-1.3h0.5v-0.3 h-1.3v0.3h0.5v1.3H152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.8,95.4H74V32.8h34.9V95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.2,64.1c0-12.7,5.9-24,15.2-31.3c-6.8-5.3-15.3-8.5-24.6-8.5c-22,0-39.8,17.8-39.8,39.8 s17.8,39.8,39.8,39.8c9.3,0,17.8-3.2,24.6-8.5C82.2,88.1,76.2,76.8,76.2,64.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.9,64.1c0,22-17.8,39.8-39.8,39.8c-9.3,0-17.8-3.2-24.6-8.5c9.3-7.3,15.2-18.6,15.2-31.3 s-5.9-24-15.2-31.3c6.8-5.3,15.3-8.5,24.6-8.5C138,24.3,155.9,42.1,155.9,64.1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154.6-15.1v-1.5h-0.4l-0.5,1l-0.5-1H153v1.5h0.3v-1.2l0.5,1h0.3l0.5-1v1.2H154.6z M152.1-15.1v-1.3h0.5v-0.3 h-1.3v0.3h0.5v1.3H152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M108.8-8.5H74v-62.6h34.9V-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.2-39.8c0-12.7,5.9-24,15.2-31.3c-6.8-5.3-15.3-8.5-24.6-8.5c-22,0-39.8,17.8-39.8,39.8S44.9,0,66.8,0 c9.3,0,17.8-3.2,24.6-8.5C82.2-15.8,76.2-27.1,76.2-39.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.9-39.8C155.9-17.8,138,0,116,0c-9.3,0-17.8-3.2-24.6-8.5c9.3-7.3,15.2-18.6,15.2-31.3s-5.9-24-15.2-31.3 c6.8-5.3,15.3-8.5,24.6-8.5C138-79.6,155.9-61.8,155.9-39.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterSecurebeli);
export default __webpack_public_path__ + "static/media/Master Secure beli.4ebd3dfe9226e0e84c9c31571323c4ff.svg";
export { ForwardRef as ReactComponent };